// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2979":"f859cbc3","3559":"f859cbc3","4390":"4fa483b5","4624":"4fa483b5","4728":"4fa483b5","6952":"4fa483b5","7057":"f859cbc3","9581":"8427b1a7"}[chunkId] + ".chunk.css";
};